module.exports = __webpack_public_path__ + "img/1.3bc8338d.png";